import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import dayjs from 'dayjs'

const usePatGeneralMeds = () => {
  const patMedHistState = useSelector((state) => state.patMedHist.data)
  const [generalMeds, setGeneralMeds] = useState([])

  useEffect(() => {
    if (!patMedHistState?.meds?.list) {
      return
    }

    // Filter out medications that have an end date in the past
    const currentMeds = patMedHistState.meds.list.filter((med) => {
      // If there's no end date, it's a current medication
      if (!med.endDate) return true

      // If there is an end date, check if it's in the future
      return dayjs(med.endDate).isAfter(dayjs())
    })

    setGeneralMeds(currentMeds)
  }, [patMedHistState])

  return {
    generalMeds
  }
}

export default usePatGeneralMeds
